/* Little Big Supply: My Garage + ship-today countdown.
   Config comes from snippets/lbs-live.liquid (window.LBS_LIVE). No dependencies. */
(function () {
  'use strict';
  var CFG = window.LBS_LIVE || {};
  var VEH = (CFG.vehicles || []).filter(Boolean);
  var KEY = 'lbs-garage';
  var FIT_ONLY = 'lbs-fit-only';

  /* ---------- helpers ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function getLS(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function setLS(k, v) { try { if (v == null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch (e) {} }
  function getSS(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function setSS(k, v) { try { if (v == null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v); } catch (e) {} }
  function byHandle(h) { for (var i = 0; i < VEH.length; i++) if (VEH[i].h === h) return VEH[i]; return null; }
  function stripYears(name) { return String(name || '').replace(/\s*\([^)]*\)\s*$/, ''); }

  /* ---------- garage state ---------- */
  function current() {
    var raw = getLS(KEY);
    if (!raw) return null;
    try { raw = JSON.parse(raw); } catch (e) { return null; }
    var v = raw && byHandle(raw.h);
    return v ? { v: v, year: raw.year || '' } : null;
  }
  function saveGarage(h, year) {
    setLS(KEY, h ? JSON.stringify({ h: h, year: year || '' }) : null);
    renderAll();
    try { document.dispatchEvent(new CustomEvent('lbs:garage', { detail: current() })); } catch (e) {}
  }
  function longLabel(c) { return c.year ? c.year + ' ' + stripYears(c.v.name) : c.v.name; }
  function shortLabel(c) { return c.year ? c.year + ' ' + String(c.v.short || '').replace(/\s+\d{2,4}\s*[–—-]\s*\d{2,4}$/, '') : c.v.short; }
  function yearsFor(v) {
    var m = String(v.years || '').match(/(\d{4})\s*(?:[–—-]\s*(\d{4})|(\+))?/);
    if (!m) return [];
    var a = +m[1], b = m[2] ? +m[2] : (m[3] ? new Date().getFullYear() + 1 : a);
    var out = [];
    for (var y = b; y >= a; y--) out.push(String(y));
    return out;
  }

  /* ---------- dialog ---------- */
  var dlg, selV, selY, shopLink;
  function buildDialog() {
    if (dlg) return dlg;
    dlg = el('dialog', 'lbs-garage');
    dlg.id = 'LbsGarage';
    dlg.setAttribute('aria-labelledby', 'LbsGarageTitle');
    var form = el('form', 'lbs-garage__inner');
    form.method = 'dialog';
    var close = el('button', 'lbs-garage__close', '×');
    close.value = 'cancel';
    close.setAttribute('aria-label', 'Close');
    var h = el('h2', 'lbs-garage__title', 'My garage');
    h.id = 'LbsGarageTitle';
    var p = el('p', 'lbs-garage__lede', 'Save your car and we’ll flag what fits while you shop.');
    var l1 = el('label', null, 'Vehicle'); l1.htmlFor = 'LbsGarageVeh';
    selV = el('select'); selV.id = 'LbsGarageVeh';
    selV.appendChild(new Option('Choose your car', ''));
    VEH.forEach(function (v) { selV.appendChild(new Option(v.name, v.h)); });
    var l2 = el('label', null, 'Year (optional)'); l2.htmlFor = 'LbsGarageYear';
    selY = el('select'); selY.id = 'LbsGarageYear';
    selV.addEventListener('change', fillYears);
    var actions = el('div', 'lbs-garage__actions');
    var save = el('button', 'lbs-btn lbs-btn--volt', 'Save my car'); save.value = 'save';
    var clear = el('button', 'lbs-btn lbs-btn--ghost', 'Clear'); clear.value = 'clear';
    actions.appendChild(save); actions.appendChild(clear);
    shopLink = el('a', 'lbs-link lbs-garage__shop');
    form.appendChild(close); form.appendChild(h); form.appendChild(p);
    form.appendChild(l1); form.appendChild(selV); form.appendChild(l2); form.appendChild(selY);
    form.appendChild(actions); form.appendChild(shopLink);
    dlg.appendChild(form);
    dlg.addEventListener('close', function () {
      if (dlg.returnValue === 'save' && selV.value) saveGarage(selV.value, selY.value);
      if (dlg.returnValue === 'clear') saveGarage(null);
      var opener = document.getElementById('LbsGarageBtn');
      if (opener) opener.setAttribute('aria-expanded', 'false');
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close('cancel'); });
    document.body.appendChild(dlg);
    return dlg;
  }
  function fillYears() {
    var v = byHandle(selV.value);
    selY.textContent = '';
    selY.appendChild(new Option('Any year', ''));
    if (v) yearsFor(v).forEach(function (y) { selY.appendChild(new Option(y, y)); });
    selY.disabled = !v;
  }
  function openGarage(preset) {
    buildDialog();
    var c = current();
    selV.value = preset || (c ? c.v.h : '');
    fillYears();
    if (c && selV.value === c.v.h) selY.value = c.year;
    if (c && c.v.col) {
      shopLink.href = c.v.col;
      shopLink.textContent = 'Shop all ' + c.v.short + ' parts';
      shopLink.hidden = false;
    } else {
      shopLink.hidden = true;
    }
    var opener = document.getElementById('LbsGarageBtn');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    selV.focus();
  }
  window.LBSGarage = { open: openGarage, get: current, set: saveGarage };

  /* ---------- header chip ---------- */
  var CAR = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 15v-3l2-5h11l3 5h2v3"/><path d="M3 15h18"/><circle cx="7" cy="16.5" r="2"/><circle cx="17" cy="16.5" r="2"/></svg>';
  function renderChip() {
    if (!VEH.length) return;
    var icons = document.querySelector('.header__icons');
    if (!icons) return;
    var b = document.getElementById('LbsGarageBtn');
    if (!b) {
      b = el('button', 'lbs-garage-btn');
      b.type = 'button';
      b.id = 'LbsGarageBtn';
      b.setAttribute('aria-haspopup', 'dialog');
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () { openGarage(); });
      icons.insertBefore(b, icons.firstChild);
    }
    var c = current();
    b.innerHTML = CAR;
    var t = el('span', 'lbs-garage-btn__text', c ? shortLabel(c) : 'My garage');
    b.appendChild(t);
    b.classList.toggle('is-set', !!c);
    b.setAttribute('aria-label', c ? 'My garage: ' + longLabel(c) + '. Change vehicle' : 'My garage: add your vehicle');
  }

  /* ---------- product page fit badge ---------- */
  function renderFit() {
    var nodes = document.querySelectorAll('[data-lbs-fit]');
    if (!nodes.length) return;
    var c = current();
    Array.prototype.forEach.call(nodes, function (node) {
      var list = (node.getAttribute('data-lbs-fit') || '').split(',').filter(Boolean);
      node.textContent = '';
      node.hidden = false;
      var change = el('button', 'lbs-garage-fit__change', c ? 'Change car' : 'Add your car');
      change.type = 'button';
      change.addEventListener('click', function () { openGarage(); });
      if (!c) {
        node.className = 'lbs-garage-fit lbs-garage-fit--ask';
        node.appendChild(el('span', null, 'Will it fit? Save your car and we’ll check every part for you.'));
        node.appendChild(change);
        return;
      }
      if (list.indexOf(c.v.h) > -1) {
        node.className = 'lbs-garage-fit lbs-garage-fit--yes';
        node.appendChild(el('span', 'lbs-garage-fit__mark', '✓'));
        var s = el('span', null, 'Fits your ');
        s.appendChild(el('strong', null, longLabel(c)));
        node.appendChild(s);
      } else {
        node.className = 'lbs-garage-fit lbs-garage-fit--no';
        node.appendChild(el('span', 'lbs-garage-fit__mark', '!'));
        var s2 = el('span', null, 'Not listed for your ');
        s2.appendChild(el('strong', null, longLabel(c)));
        s2.appendChild(document.createTextNode('. '));
        if (c.v.col) {
          var a = el('a', 'lbs-link', 'Shop ' + c.v.short + ' parts');
          a.href = c.v.col;
          s2.appendChild(a);
        }
        node.appendChild(s2);
      }
      node.appendChild(change);
    });
  }

  /* ---------- required-for-fitment adapters (wheel + tire pages) ---------- */
  function renderReqFit() {
    var boxes = document.querySelectorAll('[data-lbs-reqfit]');
    if (!boxes.length) return;
    var c = current();
    Array.prototype.forEach.call(boxes, function (box) {
      var list = box.querySelector('.lbs-recs__list');
      if (!list) return;
      Array.prototype.forEach.call(list.querySelectorAll('[data-lbs-fitkeys]'), function (marker) {
        var row = marker.previousElementSibling;
        if (!row) return;
        var note = row.querySelector('.lbs-rec__note');
        if (note && !note.hasAttribute('data-orig')) note.setAttribute('data-orig', note.textContent);
        var fits = !!c && (marker.getAttribute('data-lbs-fitkeys') || '').indexOf(',' + c.v.h + ',') > -1;
        row.classList.toggle('is-yours', fits);
        if (note) note.textContent = fits ? 'Fits your ' + longLabel(c) : note.getAttribute('data-orig');
        if (fits && list.firstElementChild !== row) { list.insertBefore(marker, list.firstChild); list.insertBefore(row, marker); }
      });
    });
  }

  /* ---------- collection bar + fit filter ---------- */
  var gridObs = null;
  function cardHandle(li) {
    var a = li.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function loadFitSet(colHandle) {
    var key = 'lbs-fitset-' + colHandle;
    var cached = getSS(key);
    if (cached) { try { return Promise.resolve(JSON.parse(cached)); } catch (e) {} }
    var handles = [];
    function page(n) {
      return fetch('/collections/' + encodeURIComponent(colHandle) + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          (d.products || []).forEach(function (p) { handles.push(p.handle); });
          if ((d.products || []).length === 250 && n < 8) return page(n + 1);
        });
    }
    return page(1).then(function () { setSS(key, JSON.stringify(handles)); return handles; });
  }
  function applyFilter(c, on, bar) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var items = grid.querySelectorAll(':scope > li, :scope > .grid__item');
    var note = bar.querySelector('.lbs-garage-bar__count');
    if (!on || !c || !c.v.colHandle) {
      Array.prototype.forEach.call(items, function (li) { li.hidden = false; });
      if (note) note.textContent = '';
      return;
    }
    loadFitSet(c.v.colHandle).then(function (set) {
      var hidden = 0;
      Array.prototype.forEach.call(items, function (li) {
        var h = cardHandle(li);
        var hide = !!h && set.indexOf(h) === -1;
        li.hidden = hide;
        if (hide) hidden++;
      });
      if (note) note.textContent = hidden ? hidden + ' on this page hidden' : 'Everything on this page fits';
    });
  }
  function renderCollectionBar() {
    if (!/^\/collections\/[^/]+\/?$/.test(location.pathname)) return;
    var container = document.getElementById('ProductGridContainer');
    if (!container || !VEH.length) return;
    var bar = document.getElementById('LbsGarageBar');
    if (!bar) {
      bar = el('div', 'lbs-garage-bar page-width');
      bar.id = 'LbsGarageBar';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'My garage');
      container.parentNode.insertBefore(bar, container);
    }
    bar.textContent = '';
    var c = current();
    var path = location.pathname.replace(/\/$/, '');
    var pageVeh = null;
    VEH.forEach(function (v) { if (v.col && v.col.replace(/\/$/, '') === path) pageVeh = v; });
    var txt = el('p', 'lbs-garage-bar__text');
    bar.appendChild(txt);

    if (pageVeh) {
      if (c && c.v.h === pageVeh.h) {
        txt.appendChild(el('span', 'lbs-garage-fit__mark', '✓'));
        txt.appendChild(document.createTextNode(' Everything here is for your '));
        txt.appendChild(el('strong', null, longLabel(c)));
        txt.appendChild(document.createTextNode('.'));
        return;
      }
      txt.appendChild(document.createTextNode(c ? 'Your garage has the ' : 'Is this your car? '));
      if (c) { txt.appendChild(el('strong', null, longLabel(c))); txt.appendChild(document.createTextNode('. These parts are for the ' + pageVeh.name + '.')); }
      var sw = el('button', 'lbs-btn lbs-btn--ink lbs-btn--sm', c ? 'Switch to this car' : 'Save ' + pageVeh.short + ' to My Garage');
      sw.type = 'button';
      sw.addEventListener('click', function () { openGarage(pageVeh.h); });
      bar.appendChild(sw);
      if (c && c.v.col) {
        var back = el('a', 'lbs-link', 'Shop ' + c.v.short + ' parts');
        back.href = c.v.col;
        bar.appendChild(back);
      }
      return;
    }

    if (!c) {
      txt.appendChild(document.createTextNode('Shopping for one car? Save it and we’ll show only the parts that fit.'));
      var add = el('button', 'lbs-btn lbs-btn--ink lbs-btn--sm', 'Add my car');
      add.type = 'button';
      add.addEventListener('click', function () { openGarage(); });
      bar.appendChild(add);
      return;
    }
    txt.appendChild(document.createTextNode('Your garage: '));
    txt.appendChild(el('strong', null, longLabel(c)));
    var lab = el('label', 'lbs-garage-bar__toggle');
    var cb = el('input'); cb.type = 'checkbox'; cb.checked = getSS(FIT_ONLY) === '1';
    lab.appendChild(cb);
    lab.appendChild(document.createTextNode(' Only show parts that fit'));
    bar.appendChild(lab);
    bar.appendChild(el('span', 'lbs-garage-bar__count'));
    var chg = el('button', 'lbs-garage-fit__change', 'Change car');
    chg.type = 'button';
    chg.addEventListener('click', function () { openGarage(); });
    bar.appendChild(chg);
    cb.addEventListener('change', function () { setSS(FIT_ONLY, cb.checked ? '1' : null); applyFilter(c, cb.checked, bar); });
    applyFilter(c, cb.checked, bar);
    if (!gridObs && window.MutationObserver) {
      gridObs = new MutationObserver(function () {
        var b = document.getElementById('LbsGarageBar');
        var box = b && b.querySelector('input[type="checkbox"]');
        if (box && box.checked) applyFilter(current(), true, b);
      });
      gridObs.observe(container, { childList: true, subtree: true });
    }
  }

  /* ---------- ship-today countdown ---------- */
  var SHIP = CFG.ship || null;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function ptNow() {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: SHIP.tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
    var o = {};
    f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    var h = +o.hour % 24;
    return { y: +o.year, m: +o.month, d: +o.day, secs: h * 3600 + (+o.minute) * 60 + (+o.second) };
  }
  function iso(y, m, d) { return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d; }
  function isShipDay(dt) {
    var wd = dt.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    return (SHIP.holidays || []).indexOf(iso(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate())) === -1;
  }
  function shipMessage() {
    var n = ptNow();
    var today = new Date(Date.UTC(n.y, n.m - 1, n.d));
    var cutoff = (SHIP.cutoffHour || 13) * 3600;
    if (isShipDay(today) && n.secs < cutoff) {
      var left = Math.max(60, cutoff - n.secs);
      var hrs = Math.floor(left / 3600), mins = Math.floor((left % 3600) / 60);
      return { urgent: true, lead: 'Order in ', time: (hrs ? hrs + 'h ' : '') + mins + 'm', tail: ' and it ships ', day: 'today' };
    }
    var next = new Date(today.getTime());
    for (var i = 1; i < 14; i++) {
      next = new Date(today.getTime() + i * 86400000);
      if (isShipDay(next)) break;
    }
    var label = (next.getTime() - today.getTime() === 86400000) ? 'tomorrow' : DAYS[next.getUTCDay()];
    return { urgent: false, lead: 'Order now and it ships ', time: '', tail: '', day: label };
  }
  function paintClock(node, msg) {
    var sig = msg.lead + msg.time + msg.day;
    if (node.getAttribute('data-sig') === sig) return;
    node.setAttribute('data-sig', sig);
    node.textContent = '';
    node.classList.toggle('is-urgent', msg.urgent);
    node.appendChild(el('span', 'lbs-shipclock__dot'));
    var s = el('span', null, msg.lead);
    if (msg.time) { s.appendChild(el('strong', null, msg.time)); s.appendChild(document.createTextNode(msg.tail)); }
    s.appendChild(el('strong', null, msg.day));
    s.appendChild(document.createTextNode('.'));
    node.appendChild(s);
  }
  function tickClock() {
    if (!SHIP || !window.Intl) return;
    Array.prototype.forEach.call(document.querySelectorAll('.cart__ctas'), function (ctas) {
      var prev = ctas.previousElementSibling;
      if (!prev || !prev.hasAttribute('data-lbs-shipclock')) {
        var p = el('p', 'lbs-shipclock lbs-shipclock--cart');
        p.setAttribute('data-lbs-shipclock', '');
        ctas.parentNode.insertBefore(p, ctas);
      }
    });
    var nodes = document.querySelectorAll('[data-lbs-shipclock]');
    if (!nodes.length) return;
    var msg;
    try { msg = shipMessage(); } catch (e) { return; }
    Array.prototype.forEach.call(nodes, function (n) { paintClock(n, msg); });
  }

  /* ---------- boot ---------- */
  function renderAll() { renderChip(); renderFit(); renderReqFit(); renderCollectionBar(); }
  function boot() {
    renderAll();
    tickClock();
    setInterval(tickClock, 1000);
    window.addEventListener('storage', function (e) { if (e.key === KEY) renderAll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
